export const urlSyncScript = `
(function() {
  console.log('[URL Sync] Initializing iframe URL synchronization');
  
  let lastUrl = window.location.href;
  let isInitialized = false;
  
  function notifyParent(url, reason) {
    try {
      console.log('[URL Sync] URL changed:', url, 'Reason:', reason);
      window.parent.postMessage({
        type: 'iframe-url-change',
        url: url,
        reason: reason,
        timestamp: Date.now()
      }, '*');
    } catch (e) {
      console.error('[URL Sync] Cannot send message to parent:', e);
    }
  }
  
  function checkUrlChange(reason = 'periodic') {
    const currentUrl = window.location.href;
    if (currentUrl !== lastUrl) {
      lastUrl = currentUrl;
      notifyParent(currentUrl, reason);
    }
  }
  
  window.addEventListener('popstate', () => checkUrlChange('popstate'));
  window.addEventListener('hashchange', () => checkUrlChange('hashchange'));
  
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;
  
  history.pushState = function() {
    originalPushState.apply(history, arguments);
    setTimeout(() => checkUrlChange('pushState'), 0);
  };
  
  history.replaceState = function() {
    originalReplaceState.apply(history, arguments);
    setTimeout(() => checkUrlChange('replaceState'), 0);
  };
  
  document.addEventListener('click', function(e) {
    const target = e.target.closest('a');
    if (target && target.href) {
      try {
        const targetUrl = new URL(target.href);
        const currentUrl = new URL(window.location.href);
        if (targetUrl.origin === currentUrl.origin) {
          setTimeout(() => checkUrlChange('link-click'), 100);
        }
      } catch (err) {
      }
    }
  });
  
  document.addEventListener('submit', function(e) {
    setTimeout(() => checkUrlChange('form-submit'), 100);
  });
  
  setInterval(() => checkUrlChange('interval'), 2000);
  
  function initialize() {
    if (!isInitialized) {
      isInitialized = true;
      notifyParent(window.location.href, 'initialization');
      console.log('[URL Sync] Initialization complete');
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    setTimeout(initialize, 100);
  }
})();
`;

export const getUrlSyncScript = (debug = false) => {
  if (debug) {
    return urlSyncScript;
  }

  return urlSyncScript.replace(/console\.(log|error)\([^)]*\);?\s*/g, '');
};
